import { ArrowRight, ClipboardCheck } from "lucide-react";
import { CHECKOUT_URL } from "@/constants/checkout";
import { Eyebrow, Reveal } from "./Reveal";

const chapters = [
  { title: "A verdade sobre não saber montar o prato", desc: "Por que ninguém te ensinou isso — e por que não é sua culpa." },
  { title: "O que muda quando existe método", desc: "A diferença entre tentar comer bem e realmente conseguir." },
  { title: "Antes de começar: o mínimo necessário", desc: "O básico que você precisa (e o que pode ignorar sem medo)." },
  { title: "Passo 1 — Escolher o ponto de partida", desc: "Comece pelo essencial e elimine o que só atrapalha." },
  { title: "Passo 2 — Montar o cardápio semanal", desc: "Planeje a semana inteira sem passar horas na cozinha." },
  { title: "Passo 3 — A primeira semana na prática", desc: "Execute com confiança, mesmo com a agenda lotada." },
  { title: "Passo 4 — Medir o que importa", desc: "Os sinais certos de progresso, além do número da balança." },
  { title: "Passo 5 — Ajustar sem recomeçar", desc: "Adapte o plano à vida real sem voltar à estaca zero." },
  { title: "Os erros que custam caro", desc: "As armadilhas que derrubam 9 em cada 10 pessoas." },
  { title: "Manter o ritmo sem depender de motivação", desc: "Hábito e processo no lugar da força de vontade." },
  { title: "Da primeira semana ao próximo nível", desc: "O caminho para transformar uma semana em estilo de vida." },
];

export default function Chapters() {
  return (
    <section id="capitulos" data-testid="chapters-section" className="bg-forest py-24 text-cream sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow className="text-ochre">Dentro do e-book</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">
                11 capítulos para ler numa tarde —{" "}
                <span className="italic text-ochre">e usar pela vida inteira</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="flex max-w-xs items-start gap-2 text-sm leading-relaxed text-cream/70">
              <ClipboardCheck size={18} className="mt-0.5 shrink-0 text-ochre" />
              Cada capítulo termina com um exercício prático e um checklist para você aplicar no mesmo dia.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {chapters.map((ch, i) => (
            <Reveal key={ch.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`chapter-card-${i + 1}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-ochre/40 hover:bg-white/[0.07]"
              >
                <span className="pointer-events-none absolute -right-2 -top-5 select-none font-serif text-8xl font-bold text-cream/[0.07] transition-colors duration-500 group-hover:text-ochre/20">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-ochre">
                  Capítulo {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="mt-3 font-serif text-xl font-medium leading-snug">{ch.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-cream/65">{ch.desc}</p>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.16}>
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="chapters-cta-card"
              className="cta-shine group flex h-full min-h-[190px] flex-col justify-between rounded-3xl bg-terracotta p-7 text-cream transition-transform duration-300 hover:-translate-y-1.5"
            >
              <h3 className="font-serif text-2xl font-semibold leading-snug">
                Pronta para o capítulo 1 da sua nova rotina?
              </h3>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider">
                Garantir meu e-book
                <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1.5" />
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
